import { Controller } from '@hotwired/stimulus'

/*
 * Stimulus controller for the Confrère "Create ad" LiveComponent form.
 * Ensures every Summernote textarea inside the form pushes its current
 * content into the underlying <textarea> (and thus into the DTO) before
 * the LiveComponent submit action runs.
 */
export default class extends Controller {
    handleSubmitClick(event) {
        event.preventDefault()
        this._syncAllSummernotes()
        this.element.requestSubmit()
    }

    _syncAllSummernotes() {
        const app = this.application
        const nodes = this.element.querySelectorAll('[data-controller*="summernote-textarea"]')

        nodes.forEach((el) => {
            const ctrl = app.getControllerForElementAndIdentifier(el, 'summernote-textarea')
            if (ctrl) {
                ctrl.syncToLiveComponent()
            }
        })
    }
}
